import ToTop from '@/components/atoms/ToTop';
import { cn } from '@devsisters/wds-react';
import React from 'react';
import { useEventListener } from 'usehooks-ts';

type DivProps = React.ComponentPropsWithoutRef<'div'>;

type Props = DivProps;
function ActionButtons(props: Props) {
  const { className, ...divProps } = props;
  const [isTop, setIsTop] = React.useState(true);

  useEventListener('scroll', () => {
    setIsTop(window.scrollY === 0);
  });

  return (
    <div
      className={cn(
        'fixed bottom-10 flex w-full justify-end act-prevent',
        'opacity-0 transition-opacity duration-150',
        !isTop && 'opacity-100',
        className,
      )}
      {...divProps}
    >
      <div className={cn('container-layout mx-auto flex justify-end overflow-visible')}>
        <ToTop className={'act-allow'} />
      </div>
    </div>
  );
}

export default ActionButtons;
